import { Navigate, useLocation } from 'react-router-dom';
import type { JSX } from 'react';
import { useAuth } from '../../providers/AuthContext';
import { ROLES } from '../../../shared/config/constants';
import { canAccessAdminEmployeeLms } from '../../../shared/lib/employeePortal';

interface RequireAdminEmployeeLmsProps {
    children: JSX.Element;
}

/** Periode belajar & kursus karyawan di admin: admin penuh, atau instruktur yang punya identitas karyawan. */
export const RequireAdminEmployeeLms = ({ children }: RequireAdminEmployeeLmsProps) => {
    const { user, isAuthenticated } = useAuth();
    const location = useLocation();

    if (!isAuthenticated || !user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (user.role !== ROLES.ADMIN && user.role !== ROLES.INSTRUCTOR) {
        return <Navigate to="/admin" replace />;
    }

    if (!canAccessAdminEmployeeLms(user)) {
        return <Navigate to="/admin" replace />;
    }

    return children;
};
